import { Spinner } from '@heroui/react';
import React, { FC } from 'react';

import { Container, SPIN_DURATION_MS } from './DashboardLoadingIcon.styled';

interface DashboardLoadingIconProps {
  /** @deprecated rozmiar jest stały - prop zachowany dla kompatybilności */
  size?: 'sm' | 'md' | 'lg';
  title?: string;
  description?: string;
  /** Zakryj cały viewport (tylko gdy pod spodem nie ma jeszcze layoutu). */
  fullscreen?: boolean;
}

/**
 * Loader aplikacji: ten sam mały spinner HeroUI co na przycisku „Zaloguj", w kolorze
 * akcentu DS zamiast bieli. Jeden wygląd od formularza logowania, przez bramkę startową,
 * po treść Dashboardu, więc kolejne etapy ładowania nie wyglądają jak różne ekrany.
 *
 * Domyślnie wypełnia rodzica (treść pod sidebarem), `fullscreen` zakrywa viewport.
 * `--hs-spin-phase` synchronizuje fazę obrotu między kolejnymi montażami (patrz styled).
 */
export const DashboardLoadingIcon: FC<DashboardLoadingIconProps> = ({ fullscreen = false }) => (
  <Container
    $fullscreen={fullscreen}
    style={{ '--hs-spin-phase': `-${Date.now() % SPIN_DURATION_MS}ms` } as React.CSSProperties}
  >
    <Spinner
      size="sm"
      classNames={{
        // Cieńsza obręcz niż domyślne `border-2` w rozmiarze sm.
        circle1: 'border-b-accent-ink border-[1.5px]',
        circle2: 'border-b-accent-ink border-[1.5px]',
      }}
    />
  </Container>
);
